<template>
  <div>
    <vonap-window
      width="800px"
      height="500px"
      title="File uploader"
      @close="$emit('input', false)"
      :visible="value"
      :modal="true"
    >
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12>
            <file-upload :url="importUrl" :validate="false" @success="onSuccess" @error="onError" />
          </v-flex>
          <v-flex xs12>
            <span>{{ importMessage }}</span>
          </v-flex>
        </v-layout>
      </v-container>

      <div>
        <kendo-grid
          ref="grid"
          height="200px"
          :dataSource="dataSource"
          :editable="editableSettings"
          :filterable="true"
          :sortable="true"
          :pageable-always-visible="true"
          :columns="columns"
        >
        </kendo-grid>
      </div>
    </vonap-window>
  </div>
</template>
<script>
import eventBus from '@/helpers/event-bus'
import {mapGetters} from 'vuex'
import notification from '@/helpers/notification'
import FileUpload from './FileUpload'
import security from '@/mixins/security'
import VonapWindow from '@/components/VonapWindow'

export default {
  name: 'AzureStorage',
  mixins: [security],
  props: {
    value: {
      type: Boolean,
    },
    id: {
      type: Number,
      required: true,
      defaultValue: 0,
    },
    prefix: {
      type: String,
      required: true,
    },
  },
  components: {
    //PageToolbar,
    //FlowTypeToolbar,
    VonapWindow,
    FileUpload,
  },
  data() {
    return {
      showFileUploadDialog: true,
      importMessage: '',
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    editableSettings: function() {
      return {
        mode: 'inline',
        update: this.editable,
        destroy: this.editable,
        confirmation: false,
        createAt: 'bottom',
      }
    },
    importUrl() {
      return '/api/azureStorage/uploadFiles?id=' + this.id + '&prefix=' + this.prefix
    },
    isMaster() {
      return this.clientId == 0
    },
    canEdit() {
      return ['SuperAdmin', 'Admin'].includes(this.currentRole)
    },
    isReadOnly() {
      return !this.canEdit && this.isMaster
    },
    grid() {
      return this.$refs.grid
    },
    columns() {
      return [
        {
          field: 'fileName',
          title: 'Filename',
          template: '<a href="#=uri#" class="downloadFileLink" target="_blank">#=fileName#</a>',
          width: 180,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'username',
          title: 'User',
          width: 120,
        },
        {
          field: 'lastModified',
          title: 'Last Modified',
          format: '{0:yyyy-MM-dd HH:mm:ss}',
          width: 120,
        },
        {command: 'destroy', title: '&nbsp;', width: 60, hidden: !this.isMaster},
      ]
    },
    dataSource() {
      return new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 20,
        transport: {
          read: {
            type: 'GET',
            url: '/api/azureStorage',
            data: {
              id: this.id,
              prefix: this.prefix,
            },
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/azureStorage',
            data: {
              id: this.id,
              prefix: this.prefix,
            },
            dataType: 'json',
          },
        },
        requestEnd: e => {
          if (e.type != 'read') {
            this.$emit('success')
          }
        },
        batch: false,
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'fileId',
            fields: {
              fileId: {type: 'number'},
              fileName: {type: 'string'},
              username: {type: 'string'},
              lastModified: {type: 'date'},
            },
          },
        },
        error: function() {
          //let grid = $('#contractGrid').data('kendoGrid')
          //grid.one('dataBinding', e => {
          //  e.preventDefault()
          //})
        },
      })
    },
  },
  methods: {
    refreshGrid() {
      this.dataSource.read()
    },
    hideImportDialog() {
      this.showFileUploadDialog = false
      this.importMessage = ''
    },
    onError() {
      notification('Error importing the file', 'error')
    },
    onSuccess(e) {
      if (e.status == 0) {
        notification(e.message, 'info')
        this.refreshGrid()
        this.$emit('success')
        //this.hideImportDialog()
        this.importMessage = ''
      } else {
        notification(e.message, 'error')
        this.importMessage = e.message
      }
      eventBus.$emit('doReset', {foo: 'bar'})
    },
  },
}
</script>
